import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {UtilService} from '../../../../../../shared/_services/util.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Subject} from 'rxjs/Subject';
import {StatusModalComponent} from '../../../../../modals/status-modal/status-modal.component';
import {CreateBookingStayComponent} from '../../../../../modals/create-booking-stay/create-booking-stay.component';
import {FormBuilder, FormGroup} from '@angular/forms';
import {HcaUserManagementService} from '../../../../../../shared/_services/hca-user-management.service';
import {Brand} from '../../../../../../shared/_data-model/hotel-chain';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'app-members-modify',
  templateUrl: './members-modify.component.html',
  styleUrls: ['./members-modify.component.scss']
})
export class MembersModifyComponent implements OnInit {

  memberSubscription: any;
  imageUrl: string;
  memberInfo: any;
  statusModal: BsModalRef;
  bookingStayModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  destroySubscription$: Subject<boolean> = new Subject();
  physicalCardForm: FormGroup;
  duplicateEmailOf: any = [];
  emailDuplicatedBy: any = [];
  brands: Array<Brand> = [];
  brandSelected: Brand = null;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private modalService: BsModalService,
    private hcaMemberService: HcaMemberService,
    public hcaUserManagementService: HcaUserManagementService,
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action === 'action1') {
            if (this.statusModal.content.srcObject.type === 'member-edit') {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status === 0) {
                const status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivate(this.statusModal.content.srcObject.id, status,
                  this.statusModal.content.srcObject.duplicatedEmailId);
              } else {
                this.router.navigate(['/members']);
              }
            }
          }
        }
      });
  }

  errorLoading() {
    this.imageUrl = 'assets/images/profile-default.svg';
  }

  loginAsUser(memberId) {
    this.hcaMemberService.getMemberLogin(memberId, this.brandSelected.brandId).subscribe((response) => {
      if (response.error === 0 && response.responseObj.brandURL) {
        const {brandURL, memberToken, levelId} = response.responseObj;
        const url = `${brandURL}?member_token=${memberToken}&levelId=${levelId}`;
        window.open(url, '_blank');
      }
    }, err => {
      console.error('Error while getting member login data: ', err ? err.message : null);
    });
  }

  activateOrDeactivate(memberId, statusId, duplicatedEmailId) {
    console.log(`change status for ${memberId} to ${statusId === 0 ? 'Deactivate' : 'Activate'}`);
    this.hcaMemberService.activateOrDeactivateMembers(memberId, statusId, duplicatedEmailId).subscribe(res => {
      this.router.navigate(['/members']);
    }, err => {
      console.error('Error while updating comment status: ', err.message);
    });
  }

  openBookingStay(id) {
    this.bookingStayModal = this.modalService.show(CreateBookingStayComponent, {class: 'add-transaction-modal'});
    if (id) {
      this.bookingStayModal.content.memberId = id;
    }
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    const message = mode === 0 ? 'Are you sure you want to deactivate this member?' : 'Are you sure you want to activate this member?';
    const title = mode === 0 ? 'Deactivate Member' : 'Activate Member';
    const action1 = mode === 0 ? 'Deactivate' : 'Activate';
    const style = mode === 0 ? 'inactive' : 'active';
    const status = mode;
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'member-edit',
      title: title,
      message: message,
      status,
      id: [id],
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    };
  }

  getFullUrl(src) {
    const pattern = /^((http|https|ftp):\/\/)/;
    if (!pattern.test(src)) {
      return this.utilService.prependUrl(src);
    } else {
      return src;
    }
  }

  updateBadgeStatus(memberId, type) {
    this.hcaMemberService.updateBadgeEvents(memberId, type).subscribe(res => {
      if (res.error === 0) {
        this.memberInfo = res.responseObj;
        this.hcaMemberService.setMemberInfo = this.memberInfo;
      }
    }, err => {
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  getMemberInfo(memberId) {
    this.hcaMemberService.getByMemberInfoById(memberId).subscribe(res => {
      if (res.error === 0) {
        this.memberInfo = res.responseObj;
        this.setDefaultBrand();

        // To get duplicateEmailOf and emailDuplicatedBy when duplicated
        let duplicateEmail: any = {
          id: undefined,
          emailId: undefined,
        };
        if (this.memberInfo != null && !isNullOrUndefined(this.memberInfo.duplicateEmailOf)) {
          const obj = Object.create(this.memberInfo.duplicateEmailOf);
          for (const prop in obj) {
            duplicateEmail = {};
            duplicateEmail.id = prop;
            duplicateEmail.emailId = obj[prop];
            this.duplicateEmailOf.push(duplicateEmail);
          }
        }
        if (this.memberInfo != null && !isNullOrUndefined(this.memberInfo.emailDuplicatedBy)) {
          const obj = Object.create(this.memberInfo.emailDuplicatedBy);
          for (const prop in obj) {
            duplicateEmail = {};
            duplicateEmail.id = prop;
            duplicateEmail.emailId = obj[prop];
            this.emailDuplicatedBy.push(duplicateEmail);
          }
        }
        this.hcaMemberService.setMemberInfo = this.memberInfo;
        if (this.memberInfo && this.memberInfo.profileUpdate) {
          this.updateBadgeStatus(memberId, 'profileUpdate');
        }
      }
    }, err => {
      console.error('Error while getting member information by Id: ', err.message);
    });
  }

  updateTrackingStatus(data) {
    this.hcaMemberService.updateTrackingStatus(data).subscribe(res => {
      if (res.error === 0) {
        console.log('res.responseObj:::', res.responseObj);
      }
    }, err => {
      console.error('Error while updating card tracking status: ', err.message);
    });
  }

  initForm(data?) {
    this.physicalCardForm = this.fb.group({
      status: [data ? data.status : false]
    });

    this.physicalCardForm.valueChanges.subscribe(value => {
      value.trackingCardId = this.hcaMemberService.getMemberInfo.loyaltyMemberTrackingCard.trackingCardId;
      value.status = value.status ? 'Delivered' : 'Pending';
      console.log('value::', value);
      this.updateTrackingStatus(value);
    });
  }

  setDefaultBrand() {
    if (this.brands.length && this.memberInfo) {
      this.brandSelected = this.brands.find(brand => brand.brandId === this.memberInfo.brandId);
    }
  }

  getBrands() {
    this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe((response) => {
      if (response.error === 0) {
        this.brands = response.responseObj;
        this.setDefaultBrand();
      }
    });
  }

  ngOnInit() {
    const memberId = this.route.snapshot.params['id'];
    this.hcaMemberService.setMemberId = memberId;
    this.getMemberInfo(memberId);
    this.initForm();
    this.getBrands();
    this.memberSubscription = this.hcaMemberService.member$
      .takeUntil(this.destroySubscription$)
      .subscribe((state: any) => {
        if (state) {
          this.memberInfo = state;
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/smartAgents/members-management/members-modify/members-modify.component.ts